import { render, staticRenderFns } from "./routeForm.vue?vue&type=template&id=7bbbbe2c"
import script from "./routeForm.vue?vue&type=script&lang=js"
export * from "./routeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports